import { CLEANUP_STATE } from '../actions/shared'
import {
    FETCH_PRINTERS_SUCCEEDED,
    FETCH_PRINTERS_FAILED,
  } from '../actions/printer'

  const initialState = {
    byId: {},
  }

const printerReducer = (state = initialState, action) => {
    switch (action.type) {
      case CLEANUP_STATE: {

        return {
          ...initialState,
        }
      }

      case FETCH_PRINTERS_SUCCEEDED: {

        return {
          ...state,
          byId: {
            ...(action?.payload?.byId ?? {}),
          }
        }
      }

      case FETCH_PRINTERS_FAILED: {
        return state
      }

      default:
        return state
    }
  }

  export default printerReducer
